import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from "./utils/auth";
import { EnvProvider } from "./utils/env";


const ExternalRedirect = ({to}) => {
    window.location.href = to;
    return <></>;
}

function App() {

    let location = useLocation();

    useEffect(() => {
        window.gtag('set', 'page_path', location.pathname);
        window.gtag('event', 'page_view');
    }, [location]);

    return (
        <div className="App">
            <AuthProvider><EnvProvider>
                <Routes>
                    {/*Default routes*/}
                    <Route
                        path="/"
                        element={
                            <ExternalRedirect to="/n/login" />
                        }
                    />
                    <Route
                        path="/en"
                        element={
                            <ExternalRedirect to="/n/login" />
                        }
                    />
                    {/*English routes*/}
                    <Route
                        path="/en/*"
                    >
                        <Route
                            path="login"
                            element={
                                <ExternalRedirect to="/n/login" />
                            }
                        />
                        <Route
                            path="profile"
                            element={
                                <ExternalRedirect to="/n/profile" />
                            }
                        />
                        <Route
                            path="logout"
                            element={
                                <ExternalRedirect to="/n/logout" />
                            }
                        />
                        <Route
                            path="set-password"
                            element={
                                <ExternalRedirect to="/n/set-password" />
                            }
                        />
                        <Route
                            path="reset-password-request"
                            element={
                                <ExternalRedirect to="/n/reset-password-request" />
                            }
                        />
                        <Route
                            path="*"
                            element={
                                <ExternalRedirect to="/n/404" />
                            }
                        />
                    </Route>

                    {/*Hebrew routes*/}
                    <Route
                        path="/he"
                        element={
                            <ExternalRedirect to="/n/login" />
                        }
                    />
                    <Route
                        path="/he/*"
                    >
                        <Route
                            path="login"
                            element={
                                <ExternalRedirect to="/n/login" />
                            }
                        />
                        <Route
                            path="profile"
                            element={
                                <ExternalRedirect to="/n/profile" />
                            }
                        />
                        <Route
                            path="logout"
                            element={
                                <ExternalRedirect to="/n/login" />
                            }
                        />
                        <Route
                            path="set-password"
                            element={
                                <ExternalRedirect to="/n/set-password" />
                            }
                        />
                        <Route
                            path="reset-password-request"
                            element={
                                 <ExternalRedirect to="/n/reset-password-request" />
                            }
                        />
                        <Route
                            path="*"
                            element={
                                <ExternalRedirect to="/n/404" />
                            }
                        />
                    </Route>
                    {/*Not found routes*/}
                    <Route
                        path="/*"
                    >
                        <Route
                            path="*"
                            element={
                                <ExternalRedirect to="/n/404" />
                            }
                        />
                    </Route>
                </Routes>
            </EnvProvider></AuthProvider>
        </div>
    );
}

export default App;
